import * as firebase from "firebase"
require("firebase/firestore")

export const getDocumentsFromCollection = (collection, references) => {
  let collectionRef = firebase.firestore().collection(collection)
  let results = []

  return (
    collectionRef
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(async doc => {
          let data = doc.data()

          let references_data = {}
          if (references) {
            for (let reference of references) {
              if (data[reference]) {
                references_data[reference] = {}
                await data[reference].get().then(reference_result => {
                  let reference_data = reference_result.data()
                  reference_data.id = reference_result.id
                  data[reference] = reference_data
                })
              }
            }
          }

          results.push({
            id: doc.id,
            ...data
          })
        })
        return results
      })
      .catch(error => {
        return error
      })
  )
}

export const getDocById = (collection, id) => {
  return firebase.firestore().collection(collection).doc(id)
}

export const getCategoriesByComponent = id => {
  let component = getDocById('components', id)

  let collectionRef = firebase.firestore().collection('categories')
  return (
    collectionRef.where('component', '==', component)
      .get()
      .then(querySnapshot => {
        let results = []
        querySnapshot.forEach(doc => {
          results.push({
            id: doc.id,
            ...doc.data()
          })
        })
        return results
      })
      .catch(error => {
        return error
      })
  )
}

export const createCategory = category => {
  let document = firebase.firestore().collection("categories").doc()
  return document
    .set({
      name: category.name,
      description: category.description,
      component: category.component,
      parent: category.parent
    })
    .then(() => {
      return document
    })
    .catch(error => {
      throw error
    })
}

export const updateCategory = category => {
  let document = firebase.firestore().collection("categories").doc(category.id)
  return document
    .update({
      name: category.name,
      description: category.description,
      component: category.component,
      parent: category.parent
    })
    .then(() => {
      return document
    })
    .catch(error => {
      throw error
    })
}

export const updateCategoryThumbnail = id => {
  let document = firebase.firestore().collection("categories").doc(id)
  return document
    .update({
      image: 'category/' + id + '.jpg'
    })
}

export const removeCategory = id => {
  let document = firebase.firestore().collection("categories").doc(id)
  return document
    .delete()
    .then(() => {
      return true
    })
    .catch(error => {
      throw error
    })
}
